var KeyCode;
(function (KeyCode) {
    KeyCode["Down"] = "Down";
    KeyCode["ArrowDown"] = "ArrowDown";
    KeyCode["Up"] = "Up";
    KeyCode["ArrowUp"] = "ArrowUp";
    KeyCode["PageDown"] = "PageDown";
    KeyCode["PageUp"] = "PageUp";
    KeyCode["Esc"] = "Esc";
    KeyCode["Escape"] = "Escape";
    KeyCode["Enter"] = "Enter";
    KeyCode["SpaceBar"] = " ";
    KeyCode["Tab"] = "Tab";
    KeyCode["Home"] = "Home";
    KeyCode["End"] = "End";
})(KeyCode || (KeyCode = {}));

export { KeyCode };
//# sourceMappingURL=KeyCode.js.map
